module.exports = __webpack_public_path__ + "static/img/product_img_3.09decec.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/product_img_3.png
// module id = XOgZ
// module chunks = 22